import { Component, Prop, h } from "@stencil/core";

@Component({
  tag: "gx-pia-message",
  styleUrl: "pia-message.scss",
  shadow: true
})
export class PiaMessage {
  /**
   * The message align
   */
  @Prop() align: 'left' | 'right';

  /**
   * The message text
   */
  @Prop() text: string;

  private _getMessageElements(){
    return [
        <gxg-column width="fluid">
            <div></div>
        </gxg-column>,
        <gxg-column width="content" class="piaMessageContent">
            <gxg-card 
            background="gray-01"
            elevation="m"
            max-width="100%"
            min-height="auto"
            padding="m"
            >
                <span class="piaMessageText">
                    {this.text.trim()}
                </span>
            </gxg-card>
        </gxg-column>
    ]
  }

  private _renderMessageElements(){
    let elements:any[] = [];
    
    if (this.align == 'left'){
        this._getMessageElements().slice().reverse().forEach(element => {
            elements.push(element);
        });
    }
    else{
        elements = this._getMessageElements();
    }
    return elements;
  }

  render() {
    return (<gxg-columns space="s" align-y="top" class="piaMessage">
        {this._renderMessageElements()}
    </gxg-columns>);
  }
}
